import PgmPages from './PgmPages';
import PlmPages from './PlmPages';
import { useIsPgm } from '../../stores/EnvironmentStore';

export default function Pages() {
    const [isPgm] = useIsPgm();

    return isPgm ? <PgmPages /> : <PlmPages />;
}
